// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/.pnpm/css-loader@7.1.4_webpack@5.105.4/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/.pnpm/css-loader@7.1.4_webpack@5.105.4/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Haven Brand Variables — "Final Haven" Identity */
:root {
  /* Brand Color Palette */
  --color-primary: #1F2A44;        /* Harbor Blue */
  --color-secondary: #4C6A58;      /* Moss Green */
  --color-surface: #F3EFE6;        /* Warm Cream */
  --color-text-primary: #5C636B;   /* Stone Deep */
  --color-text-secondary: #8A919B; /* Stone Gray */
  --color-accent: #B87333;         /* Bronze */

  /* Extended Palette */
  --color-primary-light: #2D3A56;
  --color-primary-dark: #151E32;
  --color-secondary-light: #6B847A;
  --color-secondary-dark: #3A4F41;
  --color-accent-light: #D4933D;
  --color-surface-dark: #E8E3D8;
  --color-surface-light: #FAF8F3;

  /* Semantic Colors */
  --color-success: #4C6A58;
  --color-warning: #B87333;
  --color-error: #D44C4C;
  --color-info: #5C7CBA;

  /* Light-mode border & active (overridden in .admin-layout) */
  --color-border: #E8E3D8;
  --color-active: #4C6A58;
  --color-active-text: #4C6A58;

  /* Typography */
  --font-family-primary: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  --font-family-mono: 'SF Mono', Monaco, 'Cascadia Code', 'Roboto Mono', Consolas, monospace;

  /* Spacing */
  --spacing-xs: 4px;
  --spacing-sm: 8px;
  --spacing-md: 16px;
  --spacing-lg: 24px;
  --spacing-xl: 32px;
  --spacing-2xl: 48px;

  /* Border Radius */
  --border-radius-sm: 4px;
  --border-radius-md: 8px;
  --border-radius-lg: 12px;
  --border-radius-xl: 16px;

  /* Shadows */
  --shadow-sm: 0 1px 2px 0 rgba(31, 42, 68, 0.05);
  --shadow-md: 0 4px 6px -1px rgba(31, 42, 68, 0.1), 0 2px 4px -1px rgba(31, 42, 68, 0.06);
  --shadow-lg: 0 10px 15px -3px rgba(31, 42, 68, 0.1), 0 4px 6px -2px rgba(31, 42, 68, 0.05);
  --shadow-xl: 0 20px 25px -5px rgba(31, 42, 68, 0.1), 0 10px 10px -5px rgba(31, 42, 68, 0.04);

  /* Transitions */
  --transition-fast: 150ms ease-in-out;
  --transition-normal: 250ms ease-in-out;
  --transition-slow: 350ms ease-in-out;
}

/* Admin Shell Dark Mode — scoped to .admin-layout */
.admin-layout {
  --color-surface: #1F2A44;
  --color-surface-dark: #162036;
  --color-surface-light: #263550;
  --color-text-primary: #F3EFE6;
  --color-text-secondary: #8A919B;
  --color-border: #334155;
  --color-active: #4C6A58;
  --color-active-text: #6B9B7E;
  --color-primary-light: #2D3A56;
  --color-accent-light: #D4933D;
}
`, "",{"version":3,"sources":["webpack://./../../shared/brand-variables.css"],"names":[],"mappings":"AAAA,mDAAmD;AACnD;EACE,wBAAwB;EACxB,wBAAwB,SAAS,gBAAgB;EACjD,0BAA0B,OAAO,eAAe;EAChD,wBAAwB,SAAS,eAAe;EAChD,6BAA6B,IAAI,eAAe;EAChD,+BAA+B,EAAE,eAAe;EAChD,uBAAuB,UAAU,WAAW;;EAE5C,qBAAqB;EACrB,8BAA8B;EAC9B,6BAA6B;EAC7B,gCAAgC;EAChC,+BAA+B;EAC/B,6BAA6B;EAC7B,6BAA6B;EAC7B,8BAA8B;;EAE9B,oBAAoB;EACpB,wBAAwB;EACxB,wBAAwB;EACxB,sBAAsB;EACtB,qBAAqB;;EAErB,6DAA6D;EAC7D,uBAAuB;EACvB,uBAAuB;EACvB,4BAA4B;;EAE5B,eAAe;EACf,wFAAwF;EACxF,0FAA0F;;EAE1F,YAAY;EACZ,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;;EAEnB,kBAAkB;EAClB,uBAAuB;EACvB,uBAAuB;EACvB,wBAAwB;EACxB,wBAAwB;;EAExB,YAAY;EACZ,+CAA+C;EAC/C,wFAAwF;EACxF,0FAA0F;EAC1F,4FAA4F;;EAE5F,gBAAgB;EAChB,oCAAoC;EACpC,sCAAsC;EACtC,oCAAoC;AACtC;;AAEA,oDAAoD;AACpD;EACE,wBAAwB;EACxB,6BAA6B;EAC7B,8BAA8B;EAC9B,6BAA6B;EAC7B,+BAA+B;EAC/B,uBAAuB;EACvB,uBAAuB;EACvB,4BAA4B;EAC5B,8BAA8B;EAC9B,6BAA6B;AAC/B","sourcesContent":["/* Haven Brand Variables — \"Final Haven\" Identity */\n:root {\n  /* Brand Color Palette */\n  --color-primary: #1F2A44;        /* Harbor Blue */\n  --color-secondary: #4C6A58;      /* Moss Green */\n  --color-surface: #F3EFE6;        /* Warm Cream */\n  --color-text-primary: #5C636B;   /* Stone Deep */\n  --color-text-secondary: #8A919B; /* Stone Gray */\n  --color-accent: #B87333;         /* Bronze */\n\n  /* Extended Palette */\n  --color-primary-light: #2D3A56;\n  --color-primary-dark: #151E32;\n  --color-secondary-light: #6B847A;\n  --color-secondary-dark: #3A4F41;\n  --color-accent-light: #D4933D;\n  --color-surface-dark: #E8E3D8;\n  --color-surface-light: #FAF8F3;\n\n  /* Semantic Colors */\n  --color-success: #4C6A58;\n  --color-warning: #B87333;\n  --color-error: #D44C4C;\n  --color-info: #5C7CBA;\n\n  /* Light-mode border & active (overridden in .admin-layout) */\n  --color-border: #E8E3D8;\n  --color-active: #4C6A58;\n  --color-active-text: #4C6A58;\n\n  /* Typography */\n  --font-family-primary: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;\n  --font-family-mono: 'SF Mono', Monaco, 'Cascadia Code', 'Roboto Mono', Consolas, monospace;\n\n  /* Spacing */\n  --spacing-xs: 4px;\n  --spacing-sm: 8px;\n  --spacing-md: 16px;\n  --spacing-lg: 24px;\n  --spacing-xl: 32px;\n  --spacing-2xl: 48px;\n\n  /* Border Radius */\n  --border-radius-sm: 4px;\n  --border-radius-md: 8px;\n  --border-radius-lg: 12px;\n  --border-radius-xl: 16px;\n\n  /* Shadows */\n  --shadow-sm: 0 1px 2px 0 rgba(31, 42, 68, 0.05);\n  --shadow-md: 0 4px 6px -1px rgba(31, 42, 68, 0.1), 0 2px 4px -1px rgba(31, 42, 68, 0.06);\n  --shadow-lg: 0 10px 15px -3px rgba(31, 42, 68, 0.1), 0 4px 6px -2px rgba(31, 42, 68, 0.05);\n  --shadow-xl: 0 20px 25px -5px rgba(31, 42, 68, 0.1), 0 10px 10px -5px rgba(31, 42, 68, 0.04);\n\n  /* Transitions */\n  --transition-fast: 150ms ease-in-out;\n  --transition-normal: 250ms ease-in-out;\n  --transition-slow: 350ms ease-in-out;\n}\n\n/* Admin Shell Dark Mode — scoped to .admin-layout */\n.admin-layout {\n  --color-surface: #1F2A44;\n  --color-surface-dark: #162036;\n  --color-surface-light: #263550;\n  --color-text-primary: #F3EFE6;\n  --color-text-secondary: #8A919B;\n  --color-border: #334155;\n  --color-active: #4C6A58;\n  --color-active-text: #6B9B7E;\n  --color-primary-light: #2D3A56;\n  --color-accent-light: #D4933D;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
